<template src="./ConfirmationDialog.html"></template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    emits: ["update:visible", "confirm", "cancel"],
    props: {
        visible: { type: Boolean, required: true },
        title: { type: String, default: "Confirmation" },
        message: { type: String, default: "Do you confirm operation?" },
        confirmButton: { type: String, default: "Yes" },
        cancelButton: { type: String, default: "No" },
        height: { type: Number, default: 150 }
    },
    computed: {
        popupVisible: {
            get(): boolean {
                return this.visible;
            },
            set(v: boolean) {
                this.$emit("update:visible", v);
            }
        }
    },
    methods: {
        confirm(): void {
            this.$emit("confirm");
            this.popupVisible = false;
        },
        cancel(): void {
            this.$emit("cancel");
            this.popupVisible = false;
        }
    }
});
</script>
